import cintillo from '../../assets/V2/Cintillo BPX.png'
import mapa from '../../assets/mapa.png'
import bpxTouchscreen from '../../assets/V2/bpx-touchscreen.png'
import totem from '../../assets/totem.png'
import bpxApp from '../../assets/V2/bpx-app.png'
import app from '../../assets/app.png'
import bpxMap from '../../assets/V2/bpx-mapa.png'
import brochure from '../../assets/V2/brochure.jpg'
import android from '../../assets/android.png'
import ios from '../../assets/ios.png'
export default {
  name: 'vision-v-2',
  components: {},
  props: [],
  data () {
    return {
      mapa,
      bpxTouchscreen,
      totem,
      bpxApp,
      cintillo,
      app,
      bpxMap,
      brochure,
      ios,
      android
    }
  },
  computed: {},
  mounted () {},
  methods: {}
}
